import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import type { ReactNode } from "react";

type StoreSidebarRow = {
  readonly key: string;
  readonly left: ReactNode;
  readonly right?: ReactNode;
};

export function SidebarRows({
  rows,
}: {
  readonly rows: readonly StoreSidebarRow[];
}) {
  return (
    <ul {...stylex.props(styles.list)}>
      {rows.map((row) => (
        <li key={row.key} {...stylex.props(styles.row)}>
          <span {...stylex.props(styles.rowLabel)}>{row.left}</span>
          <span {...stylex.props(styles.rowValue)}>{row.right ?? ""}</span>
        </li>
      ))}
    </ul>
  );
}

const styles = stylex.create({
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.border,
  },
  row: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: spacing.space8,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: colors.border,
    paddingBlock: spacing.space6,
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    lineHeight: 1.385,
  },
  rowLabel: {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: colors.foreground,
  },
  rowValue: {
    flexShrink: 0,
    fontSize: fontSizes.caption,
    color: colors.subtle,
  },
});
